import { Component } from '@verndale/core';

class ContentVideo extends Component {
  setupDefaults() {
    this.dom = {
      playBtn: this.el.querySelector('.content-video__container'),
      videoId: this.el.dataset.videoId,
      accountId: this.el.dataset.accountId,
    };
  }

  addListeners() {
    this.dom.playBtn.addEventListener('click', this.createModal.bind(this));
  }

  createModal() {
    const modal = document.createElement('dialog');
    modal.classList.add('content-video__modal');

    modal.innerHTML = `
      <div class="content-video__modal__content">
        <button class="content-video__modal__close-button">
          <svg class="content-video__modal__close-icon">
            <use xlink:href="#close-icon" />
          </svg>
        </button>
        <div class="content-video__modal__video">
          <iframe src="//players.brightcove.net/${this.dom.accountId}/default_default/index.html?videoId=${this.dom.videoId}" allowfullscreen="" allow="encrypted-media"></iframe>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    modal.show();
    const closeButton = modal.querySelector(
      '.content-video__modal__close-button'
    );
    closeButton.addEventListener('click', this.closeModal.bind(this));
    modal.addEventListener('click', this.closeModal.bind(this));
    document.addEventListener('keydown', this.closeModal.bind(this));
  }

  closeModal(e) {
    const modal = document.querySelector('.content-video__modal');
    const isButton = e.target.closest('.content-video__modal__close-button');
    document.body.removeAttribute('style');
    if (
      e.target === modal ||
      isButton ||
      e.keyCode === 27
    ) {
      if (modal) {
        modal.remove();
      }
    }
  }
}

export default ContentVideo;
